import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@amzn/meridian/text';
import { useBundle } from '@amzn/react-arb-tools';
import { useEffect, useRef, useState } from 'react';
import { Link, Paragraph, TruncatedParagraph } from 'src/common/styled';
export const RufusText = ({ textSection }) => {
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null);
    const text = textSection.textFragments
        .map((fragment) => fragment.textValue)
        .join('')
        .trim();
    useEffect(() => {
        if (textRef.current && text) {
            const element = textRef.current;
            setIsTruncated(element.scrollHeight > element.clientHeight);
        }
    }, [text, isBundleLoading]);
    if (isBundleLoading)
        return null;
    return (_jsxs("div", { children: [isExpanded ? (_jsx(Paragraph, { type: "b200", children: text })) : (_jsx(TruncatedParagraph, { clamp: 4, displayNewlines: true, ref: textRef, type: "b200", children: text })), isTruncated && (_jsx(Text, { type: "b200", children: _jsx(Link, { role: "button", onClick: () => setIsExpanded(!isExpanded), children: bundle.getMessage(isExpanded ? 'seeLess' : 'seeMore') }) }))] }));
};
